module.exports = __webpack_public_path__ + "static/media/ic_type_video_draft.a03cb99f.svg";